<template>
  <div class="marketing-develop">
    <h2>Expertise in EC websites<br />development</h2>
    <p class="sub-title">ECサイトの制作ノウハウ</p>
    <div class="wrap">
      <p class="min">
        ECサイトで結果を出すためには、ECサイトの構成・コンテンツ、集客や販売、ECに適した商品など、「設計」が非常に重要になります。競合よりも圧倒的に良い商品、圧倒的に価格優位性がない限り、ただECサイトを作って、結果が出るような世界では絶対にありません。ECビジネスに詳しくない人ほど、気楽に「通販をやりたい」と言いますが、通販はとても難易度が高く、しっかりとしたマーケティングと設計がないと戦うことすら難しいのが現実です。
      </p>
      <p class="min">
        では、具体的に弊社は何を設計するのかについて説明していきます。弊社では、以下の8つの要素をしっかりと固めていきます。
      </p>

      <h4>ECサイトの設計に<br class="sp-only" />重要な8要素</h4>
      <div class="box min">
        <img alt="01" src="@/assets/common/syukyaku-kyoutu-maru001.png" />
        <p>
          ネット販売の展開順<br class="tb-sp-only" /><span
            >（自社ECサイト、ECモール）</span
          >
        </p>
      </div>
      <div class="box min">
        <img alt="02" src="@/assets/common/syukyaku-kyoutu-maru002.png" />
        <p>販売する商品</p>
      </div>
      <div class="box min">
        <img alt="03" src="@/assets/common/syukyaku-kyoutu-maru003.png" />
        <p>集客方法</p>
      </div>
      <div class="box min">
        <img alt="04" src="@/assets/common/syukyaku-kyoutu-maru004.png" />
        <p>将来の発展可能を<br class="tb-sp-only" />見越したECサイトの構成</p>
      </div>
      <div class="box min">
        <img alt="05" src="@/assets/common/syukyaku-kyoutu-maru005.png" />
        <p>ECサイトのコンテンツ</p>
      </div>
      <div class="box min">
        <img alt="06" src="@/assets/common/syukyaku-kyoutu-maru006.png" />
        <p>搭載する機能</p>
      </div>
      <div class="box min">
        <img alt="07" src="@/assets/common/syukyaku-kyoutu-maru007.png" />
        <p>構築方法</p>
      </div>
      <div class="box min">
        <img alt="08" src="@/assets/common/syukyaku-kyoutu-maru008.png" />
        <p>CRM（顧客フォロー）</p>
      </div>
      <p class="min pt">
        上記のとおり、多岐に渡る細かな設計が必要となるため、通販をしたことがない事業主、通販での実績がない制作業者がECサイトを設計・制作して、形としてECサイトができても、結果が出るものでは絶対にありません。
      </p>
      <p class="min">
        カンタンにではありますが、弊社のECサイト制作ノウハウを知っていただくために、上記について1つずつ説明していきます。
      </p>
    </div>
    <div class="cover wrap">
      <div class="min" v-for="item in itemList" :key="item.id">
        <div class="title-cover">
          <img
            :alt="item.title"
            :src="require(`@/assets/common/${item.ImgPath}`)"
          />
          <p class="title" v-html="item.title"></p>
        </div>
        <div v-html="item.text"></div>
      </div>
    </div>
    <div class="wrap">
      <p class="min-box pt">
        ここまで説明したのは概要にすぎませんが、弊社では、このようなアプローチでECサイトを設計していきます。設計にかける力が違うからこそ、目的達成を目指せるECサイトを構築することができます。
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import UiFreeConsulting from "@/components/Ui/FreeConsulting.vue";
export default {
  name: "marketing-develop",
  components: {
    // UiFreeConsulting,
  },
  data() {
    return {
      itemList: [
        {
          id: 1,
          ImgPath: "syukyaku-kyoutu-maru001.png",
          title:
            "ネット販売の展開順<br><span class=small>（自社ECサイト、モール）</span>の設計",
          text: "<p class=mass>ネットショップには、自社ECサイトもあれば、楽天市場やAmazonのようなECモールもあります。お客様から「通販をやりたい」「Amazonをやりたい」と依頼を受けますが、「なぜ自社ECなのか？」「なぜAmazonなのか？」という確かたる根拠があったケースはほとんどありません。</p><p class=mass>ネット販売は、第一に「何から立ち上げるか」が重要です。これを間違えると、結果が出るはずの案件なのに結果が出なかったり、必要以上にコストと労力を要したりしてしまいます。</p><p class=mass>商材によっては、自社ECよりもECモールが有利な案件、ECモールよりも自社ECが有利な案件があります。まずはスタートとして、この見極めが非常に重要になります。</p><p class=last>さらに、コストを抑え、かつ、立ち上げ速度を上げられる効率的な展開順序があります。このような事情から、弊社では、ネット販売の展開順を必ず検討して、提案しています。</p>",
        },
        {
          id: 2,
          ImgPath: "syukyaku-kyoutu-maru002.png",
          title: "販売する商品の設計",
          text: "<p class=mass>ECサイトで販売する商品は、当然ですが、お客様が事業で取り扱っている商品です。しかし、それをそのままネット販売に持っていけば売れる、有利に戦えるかとなれば、そうではありません。</p><p class=mass>ネット販売では、ネット販売に適した商品設計、ネット販売に対応できる商品設計が非常に重要になります。たとえば、送料の問題があります。店舗で販売しているのであれば、送料は考慮不要です。しかし、ネット販売となれば、送料も含めた価格での販売となります。購入者は、その価格で競合商品との比較、購入の判断をします。</p><p class=last>そのため、なるべく送料を抑えた商品の設計をするなど、ネット販売に適した商品の設計をしていく必要があります。このような点について、弊社のこれまでの知見から具体的にアドバイスをして、販売する商品について固めていきます。</p>",
        },
        {
          id: 3,
          ImgPath: "syukyaku-kyoutu-maru003.png",
          title: "集客方法の設計",
          text: "<p class=mass>ホームページもECサイトも作ることがゴールではありません。作ったサイトを、見込み客に見てもらう必要があります。つまり、集客をする必要がある、ということです。</p><p class=mass>そのため、弊社ではECサイトの集客方法も設計します。そして、集客方法に適したECサイトの構成とコンテンツを設計して、構築していきます。</p><p class=last>集客方法には、ネット広告、SEO、SNS運用などがあり、商品に合った方法を提案します。重要なポイントは、商品やターゲットに合った集客方法を設計して実行することです。集客方法に合ったECサイトの設計と構築ができるように、集客方法はECサイトの立ち上げの段階で設計することが必須です。</p>",
        },
        {
          id: 4,
          ImgPath: "syukyaku-kyoutu-maru004.png",
          title: "将来の発展可能を見越したECサイトの構成の設計",
          text: "<p class=mass>単品リピート通販でない場合は、ECサイトで取り扱う商品ラインナップが増えたり、商品カテゴリが増えたり、新しいマーケティングの施策を実装したり、という改造が必ず発生します。このような将来の発展性を考えたECサイトの設計をすることも重要です。</p><p class=last>この視点がないと、立ち上げ後に、やりたいことができない、取り扱う商品を増やすたびに大幅な改造が必要となってお金がかかってしまう、ということになります。そのため、ECサイトの立ち上げ時から、将来像を想定し、かつ、どんな将来像になってもそれをカバーできるような柔軟な設計をします。</p>",
        },
        {
          id: 5,
          ImgPath: "syukyaku-kyoutu-maru005.png",
          title: "ECサイトのコンテンツの設計",
          text: "<p class=mass>ECサイトのコンテンツをマーケティングに基づいて設計し、構築していきます。弊社では、以下のアプローチでECサイトのコンテンツを設計します。</p><ul><li>実際に検索エンジンで検索されている検索キーワードからターゲットのニーズを調査</li><li>ターゲットがどんな悩みや希望を持っているか、何を知りたがっているかを調査</li><li>競合のネットショップのコンテンツを調査</li><li>弊社がこれまでマーケティング・構築した他ジャンルのECサイトの知見</li></ul><p class=last>これらをもとに自社の価値・強み・ポジション・ターゲットを明確にし、その上で、ECサイト上のコンテンツを設計していきます。</p>",
        },
        {
          id: 6,
          ImgPath: "syukyaku-kyoutu-maru006.png",
          title: "搭載する機能の設計",
          text: "<p class=mass>ECサイトに搭載する機能の設計を行います。ECサイトに搭載する機能は、以下の2つに分けることができます。</p><ul><li>ECサイトにおいて必須となる機能（会員登録機能、ログイン機能、決済機能、など）</li><li>あると便利な機能、成約率が上がる機能</li></ul><p class=mass>ECサイトに搭載する機能というのは、ある程度一般化されていて、新しいものを創造する、ということはほぼありません。そのため、重要なことは以下です。</p><ul><li>ECサイトにおいて必須となる機能は使いやすい形で実装する</li><li>あると便利な機能、成約率が上がる機能は、すべて理解した上で、案件や依頼の目的に合ったものを実装する</li></ul><p class=mass>ECサイトは、実装する機能がコストと制作期間に影響を与えるため、何から何まで実装すればいい、というものではありません。また、機能が過剰に増えることは、利用者にとって、ECサイトの利用難度を上げることにもつながってしまいます。本当に必要な機能、投資対効果が合う機能を選定して、それらを実装していくことが大切です。</p><p class=last>そして、実装する機能は、後述するECサイトの構築方法に影響を与えます。</p>",
        },
        {
          id: 7,
          ImgPath: "syukyaku-kyoutu-maru007.png",
          title: "構築方法の設計",
          text: "<p class=mass>ECサイトの構築方法には、大きく以下の3つがあります。</p><h4 class=left>◎フルスクラッチ</h4><p class=mass>ECサイトを1から、完全オリジナルで構築します。そのため、独自の機能を構築したり、自社特有の処理をしたり、使用中のシステムと連携したり、という自由度の高いECサイトを構築することができます。機能や処理に独自性があり、本格的なEC運営をしたい企業様を対象とした構築方法です。デメリットは、料金と制作期間ともに大きくなることです。</p><h4 class=left>◎汎用システム</h4><p class=mass>ec-force（イーシーフォース）、Shopify（ショッピファイ）、EC-CUBE（イーシーキューブ）など第三者提供の汎用システムを用いてECサイトを構築します。フルスクラッチよりも自由度は下がりますが、その分、コストも下がり、本格的なEC運営ができます。一般的な仕組みで、本格的なEC運営をしたい企業様を対象とした構築方法です。メリット・デメリットとも、上述の「フルスクラッチ」と、後述の「簡易システム」の中間というイメージです。</p><h4 class=left>◎簡易システム</h4><p class=last>BASE（ベイス）がその代表で、カンタンにECサイトを構築できます。カンタンに構築でき、気楽に始められる。これが最大のメリットです。構築のコストは安く済みますが、自由度が低くてやりたいことができない、検索エンジンでの上位表示が難しい、提供会社の方針やルール変更に影響を受ける、などのデメリットがあります。まずは手軽にECサイトを始めたい、売上を目指すわけではない、という場合に使用します。BASEは、操作を理解すれば、プログラミング知識は不要で、お客様自身での構築が可能です。これくらい簡易なECという位置づけです。</p>",
        },
        {
          id: 8,
          ImgPath: "syukyaku-kyoutu-maru008.png",
          title: "CRM（顧客フォロー）の設計",
          text: "<p class=mass>CRMは、Customer Relationship Managementを表します。日本語に訳すと「お客との関係性の管理」となります。ECサイトでは、「購入や問い合わせがあったお客様を管理し、お客様に合わせた施策を実行すること」を意味します。</p><p class=mass>CRMのカンタンな例として、化粧品のECサイトを挙げます。お客様が購入した商品、購入したタイミング、累計購入金額などのデータをECサイト内で管理します。そして、1ヶ月サイクルでリピートしてもらいたい商品の場合、「購入から20日が経過したお客様を絞り込み、フォローメールを配信」ということができます。また、「これまで5万円以上購入してくれたお客様を絞り込み、クーポンを配信」ということもできます。</p><p class=mass>このように、お客様の過去の行動（主に購入）を特定の条件で絞り込み、条件に合わせたアプローチを行うのがCRMです。</p><p class=last>ECサイトに限らず、ビジネスの売上は「新規客によるもの」と「既存客（リピーター）によるもの」に分けられます。新規の顧客を獲得し続けるコストと労力よりも、一度購入してくれた既存のお客様に対してアプローチをし、購入してもらう方が、その難易度もコストも低くなります。そのために、CRMを設計して導入することは、ECサイトにおいて重要度が高いです。</p>",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
};
</script>

<style lang="scss" scoped>
.coment {
  margin-bottom: 100px;
}

ul {
  list-style: none;
  li {
    background: url(~@/assets/common/syukyaku-kyoutu-pa001.png) no-repeat 0 0;
    background-size: auto 42px;
    color: var(--main);
    font-size: 26px;
    padding: 0px 0 40px 80px;
  }
}
:deep(h4) {
  font-size: 28px;
  color: var(--main);
  text-align: center;
  padding-bottom: 30px;
  // font-weight: bold;
  @media screen and (max-width: 767px) {
    font-size: 23px;
  }
}
:deep(.left) {
  text-align: left;
  padding-bottom: 10px;
  font-size: 25px;
}

.box {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: white;
  border-radius: 50px;
  @media screen and (max-width: 767px) {
    padding: 10px 0;
  }
  img {
    width: 100px;
    margin-right: 20px;
    @media screen and (max-width: 767px) {
      width: 100px;
      margin-right: 0;
    }
  }
  p {
    color: var(--main);
    font-size: 26px;
    @media screen and (max-width: 767px) {
      font-size: 20px;
    }
  }
  span {
    @media screen and (max-width: 767px) {
      font-size: 16px;
    }
  }
}
.pt {
  margin-top: 50px!important;
}
.cover {
  border: var(--main) solid 1px;
  padding: 100px 0 0 0;
  margin-top: 100px;
  position: relative;
  @media screen and (max-width: 767px) {
    margin-top: 0;
    padding: 50px 20px 0 20px;
    border: none;
  }
}
.title-cover {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  img {
    width: 100px;
    margin-right: 20px;
    @media screen and (max-width: 767px) {
      width: 70px;
    }
  }
  .title {
    font-size: 30px;
    color: var(--main);
    width: calc(95% - 100px);
    text-align: left;
    @media screen and (max-width: 767px) {
      font-size: 23px;
      width: calc(95% - 70px);
    }
  }
}
:deep(.last) {
  padding-bottom: 100px;
  @media screen and (max-width: 767px) {
    padding-bottom: 50px;
  }
}
:deep(.small) {
  @media screen and (max-width: 767px) {
    font-size: 20px;
  }
}
.min-box{
    width: 80%;
  margin: 0 auto;
  margin-bottom: 30px;
    @media screen and (max-width: 767px) {
    width: 100%;
  margin-bottom: 0;
  }

}
</style>
